import { Button, Dropdown } from "antd";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { key: "tr", label: "Türkçe", flag: "🇹🇷" },
  { key: "en", label: "English", flag: "🇬🇧" },
];

const getCurrentLanguage = (language) =>
  LANGUAGES.find((lang) => language?.startsWith(lang.key)) || LANGUAGES[0];

const FlagIcon = ({ flag, className = "" }) => (
  <span
    className={`inline-flex items-center justify-center text-base leading-none ${className}`}
    aria-hidden
  >
    {flag}
  </span>
);

export const LanguageSwitcher = ({ size = "middle", className = "" }) => {
  const { i18n } = useTranslation();
  const current = getCurrentLanguage(i18n.language);

  return (
    <Dropdown
      menu={{
        items: LANGUAGES.map((lang) => ({
          key: lang.key,
          label: (
            <span className="inline-flex items-center gap-2">
              <FlagIcon flag={lang.flag} />
              {lang.label}
            </span>
          ),
          onClick: () => i18n.changeLanguage(lang.key),
        })),
        selectedKeys: [current.key],
      }}
      trigger={["click"]}
      placement="bottomRight"
    >
      <Button
        type="text"
        size={size}
        className={`!text-[#64748B] hover:!text-[#334155] !inline-flex !items-center !gap-1.5 ${className}`}
        icon={<FlagIcon flag={current.flag} />}
        aria-label={current.label}
      >
        <span className="hidden sm:inline">{current.label}</span>
      </Button>
    </Dropdown>
  );
};
